class LocalStorageService {
  setItem(key: string, item: any): void {
    localStorage.setItem(key, JSON.stringify(item))
  }

  getItem<T = any>(key: string): T | null {
    const raw = localStorage.getItem(key)
    return raw ? (JSON.parse(raw) as T) : null
  }

  removeItem(key: string): void {
    localStorage.removeItem(key)
  }

  clear(): void {
    localStorage.clear()
  }
}

export default new LocalStorageService()
